import { FeatureData } from '#components/feature';

class Feature {
  private list: FeatureData[];

  setList(list: FeatureData[]): void {
    this.list = list;
  }

  isEnable(name: string): boolean {
    return this.list.some((item) => item.name === name && item.isActive);
  }
}

export { Feature };
